<template>
  <div class="resultsTable">
    <table
      :summary="tableConfigObject.tableSummary508"
      class="centered minwidth lh15">
      <thead>
        <tr class="headerRow">
          <td class="labelColumn"/>
          <th
            v-for="column in tableObj.stratColumns"
            :key="column.id + instance"
            :id="'th' + instance + column.id"
            scope="col">{{ column.name }}</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="group in tableObj.groupByRows">
          <tr :key="group.id + instance">
            <th
              :id="'gh' + instance + group.id"
              :colspan="tableObj.stratColumns.length + 1"
              scope="colgroup"
              class="groupRow"
            >{{ group.name }}</th>
          </tr>
          <tr
            v-for="(row, rownum) in groupRows(group.id)"
            :class="{bold: rownum === 0}"
            :key="'group' + instance + group.id + '_' + rownum">
            <th
              :class="{bold: rownum === 0}"
              :id="'rh' + instance + group.id + '_' + rownum"
              class="rowLabel"
              scope="row">{{ row.label }}</th>
            <td
              v-for="strat in tableObj.stratColumns"
              :headers="headers(strat.id, group.id, rownum)"
              :key="strat.id"
              class="stratData"
              v-html="row[strat.id]"/>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapGetters } from 'vuex';
import getPivotedTableViewRows from './SPTableViewUtil';

export default {
  name: 'TableView',
  props: {
    instance: {
      type: Number,
      default: 0,
    },
    tableConfigObject: {
      type: Object,
      default() {
        return {};
      },
    },
    filteredData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    ...mapState({
      lku: state => state.lku,
      // dataValueTypes: state.dataValueTypes,
      // reportDataIds: state => state.LP.reportDataIds,
      // compareId: state => state.LP.stratFilters.compareId,
    }),
    ...mapGetters([
      // 'dataValueType',
      // 'confidenceIntervalLabel',
    ]),
    tableObj() {
      return getPivotedTableViewRows(this.lku, this.filteredData, this.tableConfigObject);
    },
    duplicateRowErrors() {
      return this.tableObj.duplicateRowErrors;
    },
  },
  watch: {
    duplicateRowErrors() {
      if (!this.loadingReportDataIds) {
        // console.log('watch for duplicateRowErrors');
        this.$notify({
          // clear out previously displayed errors
          // to prevent the same errors from displaying twice
          // since the watch fires twice per table render
          clean: true,
        });
        if (this.duplicateRowErrors.length > 0) {
          this.duplicateRowErrors.forEach((error) => {
            this.$notify({
              type: 'error',
              title: 'Error: duplicate data row',
              text: error,
            });
          });
        }
      }
    },
  },
  methods: {
    groupRows(id) {
      return _(this.tableObj.pivotedTableViewRows).filter({ groupId: id }).value();
    },
    headers(stratId, groupId, rownum) {
      return `th${this.instance}${stratId} gh${this.instance}${groupId} rh${this.instance}${groupId}_${rownum}`;
    },
  },
};

</script>

<style scoped>
  .resultsTable {
    overflow: visible;
    margin: 10px;
  }

  .resultsTable table {
    border-collapse: collapse;
    font-size: smaller;
  }

  .resultsTable th,
  .resultsTable td {
    border: 1px solid grey;
  }

  td,
  th {
    padding: 0 10px;
  }

  .centered {
    margin: 0 auto;
  }

  .headerRow {
    background-color: #C1DED5;
  }

  .labelColumn {
    width: 195px;
  }

  .groupRow {
    text-align: left;
    background-color: #DEEEE9;
  }

  .rowLabel {
    font-weight: normal;
    text-align: left;
  }

  .bold {
    font-weight: bold;
  }

  .stratData {
    text-align: center;
  }

  .minwidth {
    min-width: 300px;
  }

  .lh15 {
    line-height: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SP/SPTableView.vue